import { configureStore, type Slice } from '@reduxjs/toolkit';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import { api } from '../api';
import { authListenerMiddleware } from './middlewares/authListenerMiddleware';

import { applicationSlice } from '../slice';
import { auth } from './auth';

const persistSlice = (slice: Slice)=>
    persistReducer({ key: slice.name, storage }, slice.reducer);

export const store = configureStore({
    reducer: {
        [api.reducerPath]: api.reducer,
        [applicationSlice.name]: applicationSlice.reducer,
        [auth.name]: persistSlice(auth),
    },
    middleware: getDefaultMiddleware =>
        getDefaultMiddleware({ serializableCheck: false })
            .prepend(authListenerMiddleware.middleware)
            .concat(api.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
